/* eslint-disable react/no-array-index-key */

// import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles'

import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
/**
 *
 * ListFilters
 *
 */
import React from 'react'

// import { FormattedMessage } from 'react-intl';
// import messages from './messages';

const styles = theme => ({
  tableCell: {
    color: `var(--gameday-body-textColorDark, ${theme.body.textColorDark})`,
  },
})

/* eslint-disable react/prefer-stateless-function */
class STGTableHead extends React.Component {
  render() {
    const { data, classes } = this.props

    return (
      <TableHead className={classes.tableHead}>
        <TableRow>
          {data.map(
            (column, key) => (
              <TableCell
                key={`cell${
                  // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                  key
                }`}
                numeric={column.numeric}
                padding={column.disablePadding ? 'none' : 'default'}
                className={classes.tableCell}
                style={{ width: `${column.width}` }}
              >
                {column.label}
              </TableCell>
            ),
            this
          )}
        </TableRow>
      </TableHead>
    )
  }
}

STGTableHead.defaultProps = {}
export default withStyles(styles)(STGTableHead)
